import { Container, Col, FormGroup, Form, Card, CardHeader, CardBody, Label, Button } from "reactstrap"
import { useForm } from "react-hook-form"
import ApiService from "../services/apiService"
import { method } from "lodash"
import { toast } from "react-toastify"
import { useSearchParams } from "react-router-dom"
import { getRandomValues } from "crypto"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import routes from "../routers/routes"
const CheckEmail = () => {
    const { setValue, handleSubmit, register, getValues, formState: { errors } } = useForm()
    const [searchParams] = useSearchParams();
    const [isPasswordVisible, setPasswordVisible] = useState(false);
    const email = searchParams.get('email');
    const token = searchParams.get('token');
    const toggle = () => setPasswordVisible(!isPasswordVisible);
    const navigate = useNavigate();

    setValue("email", email);

    const onSubmit = async (data: any) => {

        try {
            const response = await ApiService.axiosApi(`/auth/reset-password`, {
                method: 'POST',
                data: {
                    EmailAddress: data.email,
                    Token: token,
                    NewPassword: data.password,
                }
            })
            if (response.success) {
                toast.success("Password Reset Successfully Login to yout Account")
                navigate(routes.Login)
            } else {
                toast.error(response.message || response.status || "unale to reset password try after sometimes")
            }
        } catch (error) {
            console.log(error)
        }

    }
    return (

        <div className="d-flex justify-content-around justify-content-center align-items-center" style={{ backgroundColor: '#ebffe6', height: '100vh' }}>
            <Col xl={4}>
                <Card>
                    <CardHeader className="pb-0">
                        <h4 className="p-3 pb-0">Reset Your Password</h4>
                        <p className="px-3"> Please Enter Email & New Password</p>
                    </CardHeader>
                    <CardBody>
                        <Form className="p-4" onSubmit={handleSubmit(onSubmit)}>

                            <FormGroup>
                                <Label className="col-form-label">Email Address:</Label>
                                <input type="email"
                                    className="form-control"
                                    placeholder="Email"
                                    {...register("email", {
                                        required: "email is required"
                                    })}
                                />
                            </FormGroup>

                            <FormGroup>
                                <Label className="col-form-label">New Password:</Label>
                                <div className="form-input position-relative">
                                <input type={isPasswordVisible ? "text" : "password"} 
                                    className="form-control"
                                    placeholder="New Password"
                                    {...register("password", {
                                        required: "password is required"
                                    })}
                                />
                                <div className="show-hide" onClick={toggle}>
                                    <span className={!isPasswordVisible ? "show" : ""}> </span>
                                </div>
                                </div>
                            </FormGroup>
                            <FormGroup>
                                
                                <Label className="col-form-label">Confirm Password:</Label>
                                <div className="form-input position-relative">
                                <input type={isPasswordVisible ? "text" : "password"} 
                                    className="form-control"
                                    placeholder="Confirm Password"
                                    {...register("confirmpassword", {
                                        validate: (match) => {
                                            const password = getValues('password');
                                            return match === password || "Password should match!"
                                        }
                                    })}
                                />
                                
                                </div>
                                <p style={{ color: 'red' }}>{errors.confirmpassword?.message as string}</p>
                            </FormGroup>
                            <div className="d-flex justify-content-around">
                                <Button type="submit" color="primary">
                                    Reset Password
                                </Button>
                               </div>
                            
                        </Form>
                    </CardBody>
                </Card>
            </Col>
        </div>
    )

}
export default CheckEmail;